module.exports = __webpack_public_path__ + "static/media/Template_37.cff89927.png";